import { Link } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { FormFields } from '../types';

import FormFieldText from 'ui/shared/forms/fields/FormFieldText';

import ContractVerificationFormRow from '../ContractVerificationFormRow';

const ContractVerificationFieldConstructorArgs = () => {
  const { t } = useTranslation();
  return (
    <ContractVerificationFormRow>
      <FormFieldText<FormFields>
        name="constructor_args"
        isRequired
        rules={{ maxLength: 255 }}
        placeholder={ t('abi_encoded_Arguments') }
        size={{ base: 'md', lg: 'lg' }}
        asComponent="Textarea"
      />
      <>
        <span>{ t('add_arguments') } </span>
        <Link href="https://solidity.readthedocs.io/en/develop/abi-spec.html" target="_blank">{ t('abi_hex_form') }</Link>
        <span> { t('Constructor_arguments_created_bytecode') }</span>
        <span> { t('may_also_be') } </span>
        <Link href="https://abi.hashex.org/" target="_blank">{ t('parsed_here') }</Link>
        <span>.</span>
      </>
    </ContractVerificationFormRow>
  );
};

export default React.memo(ContractVerificationFieldConstructorArgs);
